import { render, staticRenderFns } from "./PedidoTagsCreate.vue?vue&type=template&id=6cee499a"
import script from "./PedidoTagsCreate.vue?vue&type=script&lang=js"
export * from "./PedidoTagsCreate.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports